import React from 'react';
import MerchantList from './MerchantList';

export default function Merchants() {
  return <MerchantList />;
}
